/* Is this a phone-sized screen right now?
 *
 * Most of the phone layout is CSS, and should be: a stylesheet that changes at
 * 640px costs nothing and cannot get out of step with itself. This hook is for
 * the few places where the shape of the *markup* has to change — a week that
 * is seven columns on a laptop and a list of days on a phone — and it uses the
 * same breakpoint as the stylesheet so the two never disagree.
 *
 * It answers false wherever `matchMedia` does not exist (tests, old browsers),
 * which is the desktop layout: the one every test was written against.
 */

import { useEffect, useState } from 'react';

export const PHONE_QUERY = '(max-width: 640px)';

const matches = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(PHONE_QUERY).matches
    : false;

export function useIsPhone(): boolean {
  const [phone, setPhone] = useState(matches);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const m = window.matchMedia(PHONE_QUERY);
    const on = () => setPhone(m.matches);
    on();
    m.addEventListener?.('change', on);
    return () => m.removeEventListener?.('change', on);
  }, []);
  return phone;
}
